import { Reveal } from "@/components/site/motion";
import { ShieldCheck, Lock, FileCheck2, GraduationCap, Award, Scale, Eye } from "lucide-react";

const BADGES = [
  { icon: ShieldCheck, label: "GDPR Compliant", status: "active" },
  { icon: Lock, label: "UK Data Protection", status: "active" },
  { icon: FileCheck2, label: "ICO Registration", status: "coming" },
  { icon: GraduationCap, label: "British Council Agent Training", status: "planned" },
  { icon: Award, label: "ICEF Certification", status: "planned" },
  { icon: Scale, label: "Ethical Recruitment", status: "active" },
  { icon: Eye, label: "AI Transparency", status: "active" },
];

const STATUS = {
  active: { text: "Active", cls: "bg-emerald-50 text-emerald-600" },
  coming: { text: "In Progress", cls: "bg-amber-50 text-amber-600" },
  planned: { text: "Planned", cls: "bg-slate-100 text-slate-500" },
};

export const Compliance = () => (
  <section id="compliance" data-testid="compliance-section" className="relative py-28 sm:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="max-w-2xl">
        <Reveal><p className="text-xs uppercase tracking-[0.22em] text-cobalt font-semibold">Compliance & Trust</p></Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-5 font-display font-extrabold tracking-tighter text-ink text-4xl sm:text-5xl leading-[0.98]">
            Built responsibly, from day one.
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-6 text-lg leading-relaxed text-slatey">
            Our commitment to data protection, ethical recruitment and transparent AI. Pending certifications are
            clearly marked.
          </p>
        </Reveal>
      </div>

      <div className="mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {BADGES.map((b, i) => {
          const s = STATUS[b.status];
          return (
            <Reveal key={i} delay={(i % 4) * 0.05} className="flex items-center gap-4 rounded-2xl border border-slate-200 bg-white p-5" data-testid={`compliance-badge-${i}`}>
              <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-cobalt/10">
                <b.icon className="h-6 w-6 text-cobalt" strokeWidth={1.75} />
              </div>
              <div className="min-w-0">
                <p className="text-[15px] font-semibold text-ink leading-tight">{b.label}</p>
                <span className={`mt-1.5 inline-block rounded-full px-2.5 py-0.5 text-[11px] font-semibold ${s.cls}`}>{s.text}</span>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
